// extracted by mini-css-extract-plugin
export default {"title":"EPXWamB9rBCuxNR5Aguk","limitNone":"K3i5iDM0zH4asFSlp0ho","limitActive":"XnsGMbXzSOfYNRJlEfDx","placeHolderShimmer":"pDID_Wgssa7_Q87P5v5t"};